import { render } from "./PerfilUsuarioModal.vue?vue&type=template&id=33b933f3&scoped=true"
import script from "./PerfilUsuarioModal.vue?vue&type=script&lang=js"
export * from "./PerfilUsuarioModal.vue?vue&type=script&lang=js"

import "./PerfilUsuarioModal.vue?vue&type=style&index=0&id=33b933f3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b933f3"]])

export default __exports__